import * as React from 'react'
export default function Splash() {
  const handleContactNav = () => {
    window.location.href = '/contact'
  }

  return (
    <div
      className="
        mx-auto
        min-h-screen
        bg-white
        text-slate-800
        antialiased
        dark:bg-white
        dark:text-slate-800
      "
    >
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="text-4xl font-semibold tracking-tight text-primary cursor-pointer">
            prevew
          </div>

          <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
            <a href="#how-it-works" className="hover:text-primary transition">
              How it works
            </a>
            <a href="#benefits" className="hover:text-primary transition">
              Benefits
            </a>
            {/* <a href="#for-recruiters" className="hover:text-primary transition">
                Recruiters
              </a>
              <a href="#for-candidates" className="hover:text-primary transition">
                Candidates
              </a> */}
            <a href="/contact" className="hover:text-primary transition">
              Contact
            </a>
          </nav>

          <div className="flex items-center gap-3">
            {/* <button
            className="hidden md:inline-flex px-4 py-2 text-sm font-medium text-primary border border-primary/30 rounded-lg hover:bg-primary/5 transition"
          >
            Sign in
          </button> */}
            <button
              className="inline-flex px-5 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition cursor-pointer"
              onClick={handleContactNav}
            >
              Get early access
            </button>
          </div>
        </div>
      </header>

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-linear-to-br from-primary/10 via-primary/5 to-transparent"></div>

        <div className="relative max-w-7xl mx-auto px-6 pt-12 pb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="max-w-xl">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium text-primary bg-primary/10">
                Reimagining hiring with AI
              </span>

              <h1 className="mt-6 text-4xl md:text-5xl xl:text-6xl font-semibold tracking-tight leading-tight">
                Hire beyond the resume.
              </h1>

              <p className="mt-6 text-lg text-slate-600 leading-relaxed">
                <span className="font-medium text-slate-800">prevew</span> replaces resume screening
                with AI-powered conversational interviews — giving recruiters real signal and
                candidates a fair, transparent evaluation.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <span className="px-3 py-1 text-sm rounded-md bg-slate-100 text-slate-700">
                  Conversational pre-screens
                </span>
                <span className="px-3 py-1 text-sm rounded-md bg-slate-100 text-slate-700">
                  Structured AI scoring
                </span>
                <span className="px-3 py-1 text-sm rounded-md bg-slate-100 text-slate-700">
                  Instant candidate feedback
                </span>
              </div>

              <div className="mt-12 flex flex-col sm:flex-row gap-4">
                <button
                  className="inline-flex items-center justify-center px-7 py-3 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition cursor-pointer"
                  onClick={handleContactNav}
                >
                  Request early access
                </button>
                <button className="inline-flex items-center justify-center px-7 py-3 text-sm font-medium text-primary border border-primary/30 rounded-lg hover:bg-primary/5 transition cursor-pointer">
                  See how it works
                </button>
              </div>
            </div>

            <div className="relative hidden lg:block">
              <div className="absolute -inset-4 rounded-3xl bg-primary/5 blur-2xl"></div>

              <div className="relative rounded-3xl border border-slate-200 bg-white shadow-sm p-8">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-sm text-slate-500">Candidate prevew</div>
                    <div className="mt-1 text-lg font-medium">Frontend Engineer</div>
                  </div>
                  <div className="text-sm font-semibold text-primary">Score: 87</div>
                </div>

                <div className="mt-8 space-y-5">
                  <div>
                    <div className="flex justify-between text-sm">
                      <span className="text-slate-600">Role fit</span>
                      <span className="font-medium">High</span>
                    </div>
                    <div className="mt-2 h-2 rounded bg-slate-100">
                      <div className="h-2 w-[85%] rounded bg-primary"></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between text-sm">
                      <span className="text-slate-600">Communication</span>
                      <span className="font-medium">Strong</span>
                    </div>
                    <div className="mt-2 h-2 rounded bg-slate-100">
                      <div className="h-2 w-[78%] rounded bg-primary"></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between text-sm">
                      <span className="text-slate-600">Problem solving</span>
                      <span className="font-medium">Excellent</span>
                    </div>
                    <div className="mt-2 h-2 rounded bg-slate-100">
                      <div className="h-2 w-[92%] rounded bg-primary"></div>
                    </div>
                  </div>
                </div>

                <div className="mt-8 text-sm text-slate-500">
                  Generated from AI conversational interview
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <h2 className="text-3xl font-semibold tracking-tight">
              Let’s be honest — hiring is kind of a mess.
            </h2>

            <p className="mt-6 text-slate-600 leading-relaxed">
              Job boards weren’t built for a world where AI can generate thousands of “perfect”
              applications in minutes. Recruiters are buried. Resumes blur together. Real signal
              gets lost in the noise.
            </p>

            <p className="mt-4 text-slate-600 leading-relaxed">
              Meanwhile, great candidates are filtered out by keywords, invisible rules, and
              who-knows-what. People apply, wait, refresh their inbox… and hear nothing.
            </p>

            <p className="mt-4 text-slate-700 font-medium">
              Nobody’s winning — and it doesn’t have to be this way.
            </p>
          </div>
        </div>
      </section>

      <section id="how-it-works" className="py-28">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <h2 className="text-3xl font-semibold tracking-tight">How prevew works</h2>

            <p className="mt-6 text-slate-600 leading-relaxed">
              No cover letters. No keyword games. No black box decisions.{' '}
              <span className="font-medium">prevew</span> replaces traditional screening with a
              short, structured conversation — designed to surface what actually matters.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10">
            <div className="p-7 rounded-2xl border border-slate-200 bg-white">
              <div className="text-primary font-semibold text-sm">01</div>
              <h3 className="mt-4 text-xl font-medium">Have a real conversation</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Candidates start with an AI-guided interview that feels more like a thoughtful
                conversation than an interrogation. They talk through their experience,
                decision-making, and how they approach real problems — in their own words, at their
                own pace.
              </p>
              <p className="mt-4 text-sm text-slate-500">
                No resume gymnastics. No “tell me about yourself” clichés.
              </p>
            </div>

            <div className="p-7 rounded-2xl border border-slate-200 bg-white">
              <div className="text-primary font-semibold text-sm">02</div>
              <h3 className="mt-4 text-xl font-medium">Turn answers into signal</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">
                <span className="font-medium">prevew</span> analyzes responses across multiple
                dimensions — role fit, communication, problem-solving, and practical experience. The
                result isn’t a vague “AI score,” but structured insights you can actually compare.
              </p>
              <p className="mt-4 text-sm text-slate-500">
                Think: consistent scoring, not gut feel.
              </p>
            </div>

            <div className="p-7 rounded-2xl border border-slate-200 bg-white">
              <div className="text-primary font-semibold text-sm">03</div>
              <h3 className="mt-4 text-xl font-medium">Move forward with confidence</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Recruiters see ranked candidates with clear context — what stood out, where someone
                excels, and where they may struggle. Candidates get immediate feedback and clarity
                on whether the role is a strong match.
              </p>
              <p className="mt-4 text-sm text-slate-500">
                Less guessing. Fewer dead ends. Better conversations.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="benefits" className="py-28 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <h2 className="text-3xl font-semibold tracking-tight">
              Better hiring, without the awkward parts
            </h2>

            <p className="mt-6 text-slate-600 leading-relaxed">
              <span className="font-medium text-slate-800">prevew</span> is designed to remove
              friction, guesswork, and wasted time — for the people hiring and the people applying.
              When both sides have clarity, better decisions follow.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="p-8 rounded-2xl bg-white border border-slate-200">
              <h3 className="text-xl font-medium">For recruiters</h3>

              <p className="mt-4 text-slate-600 leading-relaxed">
                Spend less time screening and more time talking to the right people.{' '}
                <span className="font-medium">prevew</span> helps you focus on signal, not
                surface-level polish.
              </p>

              <ul className="mt-6 space-y-3 text-slate-600">
                <li>• Instantly cut through AI-generated resume noise</li>
                <li>• See how candidates think, communicate, and reason</li>
                <li>• Compare applicants on consistent, structured metrics</li>
                <li>• Move forward faster — with confidence, not guesswork</li>
              </ul>
            </div>

            <div className="p-8 rounded-2xl bg-white border border-slate-200">
              <h3 className="text-xl font-medium">For candidates</h3>

              <p className="mt-4 text-slate-600 leading-relaxed">
                Finally, a process that lets you show who you are — not just how well you format a
                resume.
              </p>

              <ul className="mt-6 space-y-3 text-slate-600">
                <li>• Explain your experience in your own words</li>
                <li>• Get immediate, honest feedback after your interview</li>
                <li>• Understand whether a role is actually a good fit</li>
                <li>• Fewer applications. Fewer dead ends. Less ghosting.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="relative rounded-3xl bg-primary px-10 py-20 text-center text-white overflow-hidden">
            <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-3xl"></div>
            <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-white/10 blur-3xl"></div>

            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight">
              Ready for a new hiring experience
            </h2>

            <p className="mt-6 max-w-2xl mx-auto text-primary-100 text-lg leading-relaxed">
              <span className="font-medium">prevew</span> replaces resume roulette with real
              conversations and clear insight — so great candidates stand out and everyone knows
              where they stand.
            </p>

            <div className="mt-12 flex flex-col sm:flex-row justify-center gap-4">
              <button
                className="px-8 py-3 bg-white text-primary text-sm font-medium rounded-lg hover:bg-slate-100 transition cursor-pointer"
                onClick={handleContactNav}
              >
                Join the waitlist
              </button>
              <button
                className="px-8 py-3 border border-white/40 text-white text-sm font-medium rounded-lg hover:bg-white/10 transition cursor-pointer"
                onClick={handleContactNav}
              >
                Talk to us
              </button>
            </div>

            <p className="mt-6 text-sm text-primary-100">
              Early access • No commitment • Real feedback
            </p>
          </div>
        </div>
      </section>

      <footer className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-sm text-slate-500">© 2025 prevew. All rights reserved.</div>

          <div className="flex items-center gap-6 text-sm text-slate-500">
            <a href="#" className="hover:text-primary transition">
              Privacy
            </a>
            <a href="#" className="hover:text-primary transition">
              Terms
            </a>
            <a href="#" className="hover:text-primary transition">
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}
